import Leaks from './LeaksContainer';

export default Leaks;
